<template>
  <div class="banner-contain">
    <!--<v-total :type="type"></v-total>-->
    <div class="banner-footer">
      <!--<img  :src="img"/>-->
      <div class="banner-footer-right" v-if="isWeixin">
        <input class="searchForH5" style="width: 24rem" :placeholder="inputPlaceholder" @click="goToSearch()"/>
      </div>
      <div class="banner-footer-right" style="text-align: left;margin-left: 1rem;line-height: 1.6rem" v-else>
        <input class="searchForH5" style="width: 17rem" :placeholder="inputPlaceholder" @click="goToSearch()"/>
        <button class="download" @click="public.downloadApp()" style="line-height: 1.6rem">
          下载APP
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import TotalHeader from './TotalHeader.vue';
  export default{
    name:'header',
    props:['type'],
    data(){
      return {
        param:'',
        img:require("../../../static/img/H5_taobanner.png"),
        isWexin:this.isWexin,
        inputPlaceholder: "输入京东/拼多多商品名称或关键字"
      }
    },
    components:{
      'v-total':TotalHeader
    },
    created(){
      !this.isWeixin && (this.inputPlaceholder = "输入淘宝/天猫/京东/拼多多商品名称或关键字")
    },
    mounted(){
//      if(this.isIos){
//        document.getElementsByClassName("searchForH5")[0].style.width='9rem';
////      document.getElementsByClassName("searchForH5")[0].style.lineHeight='2rem';
//      }
    },
    methods:{
      goToSearch(){
        this.jumpToView(this.headType.searchHead)
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Header.vue?6cb9c336